module.exports = __webpack_public_path__ + "img/smzq1.98cea71b.png";